import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthContext";

interface ProtectedRouteProps {
	children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
	const { t } = useTranslation();
	const authContext = useContext(AuthContext);

	if (!authContext) {
		throw new Error("ProtectedRoute must be used within AuthProvider");
	}

	const { isAuthenticated, loading } = authContext;

	if (loading) {
		return (
			<div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-100 via-gray-50 to-primary-50">
				<div className="text-center">
					<div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-primary-200 border-t-primary-400 mb-4"></div>
					<div className="text-gray-600">{t("common.loading")}</div>
				</div>
			</div>
		);
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	return <>{children}</>;
};

export default ProtectedRoute;
